<template>
  <v-dialog
    v-model="closeDialog"
    persistent
    scrollable
    max-width="500"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        v-if="$store.getters.isInternal"
        small
        v-bind="attrs"
        v-on="on"
        @click="closeDialogInit"
      >
        <v-icon>
          mdi-check
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="title white--text secondary">
        {{ $t('supportTicketDialogClose.title') }}
      </v-card-title>
      <v-card-text>
        <Loading :loading="!loaded" />

        <v-container
          v-if="loaded && closeModel"
          fluid
        >
          <v-row>
            <v-col>
              <v-datetime-picker
                v-model="closeModel.data.closedOn"
                use-iso
                :label="$t('common.timeLabel')"
                date-format="yyyy-MM-dd"
                time-format="HH:mm:ss"
                :time-picker-props="timeProps"
              >
                <template slot="dateIcon">
                  <v-icon>mdi-calendar</v-icon>
                </template>
                <template slot="timeIcon">
                  <v-icon>mdi-clock</v-icon>
                </template>
                <template
                  slot="actions"
                  slot-scope="{ parent }"
                >
                  <v-btn
                    outlined
                    color="primary"
                    @click.native="parent.cancelHandler"
                  >
                    {{ $t('common.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    @click="parent.okHandler"
                  >
                    OK
                  </v-btn>
                </template>
              </v-datetime-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-select
                v-model="closeModel.data.closingId"
                :items="closeModel.metadata.closings"
                item-text="text"
                item-value="value"
                :label="$t('supportTicketDialogClose.cause')"
                outlined
                dense
                required
              />
              <v-alert
                v-if="!closeModel.data.closingId"
                outlined
                type="warning"
                border="top"
              >
                {{ $t('supportTicketDialogClose.selectCause') }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="closeModel.data.comment"
                :label="$t('supportTicketDialogClose.closeComment')"
                outlined
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-checkbox
                v-model="closeModel.data.createTaskRequest"
                :label="$t('supportTicketDialogClose.addToBacklog')"
              />
            </v-col>
          </v-row>
          <v-row v-if="closeModel.data.createTaskRequest">
            <v-col>
              <v-card outlined>
                <v-card-text>
                  <v-text-field
                    v-model="closeModel.data.createTaskRequestTitle"
                    :label="$t('common.title')"
                    outlined
                  />
                  <v-textarea
                    v-model="closeModel.data.createTaskRequestDescription"
                    :label="$t('common.text')"
                    outlined
                  />
                  <v-datetime-picker
                    v-model="closeModel.data.createTaskRequestRequiredOn"
                    use-iso
                    without-time
                    :label="$t('supportTicketDialogClose.requiredOn')"
                    date-format="yyyy-MM-dd"
                    time-format="HH:mm:ss"
                    :time-picker-props="timeProps"
                  >
                    <template slot="dateIcon">
                      <v-icon>mdi-calendar</v-icon>
                    </template>
                    <template slot="timeIcon">
                      <v-icon>mdi-clock</v-icon>
                    </template>
                    <template
                      slot="actions"
                      slot-scope="{ parent }"
                    >
                      <v-btn
                        outlined
                        color="primary"
                        @click.native="parent.cancelHandler"
                      >
                        {{ $t('common.cancel') }}
                      </v-btn>
                      <v-btn
                        color="secondary"
                        @click="parent.okHandler"
                      >
                        {{ $t('common.ok') }}
                      </v-btn>
                    </template>
                  </v-datetime-picker>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          color="primary"
          @click="closeDialogCancel"
        >
          {{ $t('common.cancel') }}
        </v-btn>
        <v-btn
          color="secondary"
          :loading="saving"
          :disabled="!isValid"
          @click="closeDialogSave"
        >
          {{ $t('common.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/Loading";

export default {
  name: "SupportTicketDialogClose",
  components: {
    Loading,
  },
  props: {},
  data() {
    return {
      closeModel: Object,
      closeDialog: false,
      loaded: false,
      saving: false,
      isValid: false,
      timeProps: {
        format: "24hr",
        useSeconds: true,
      },
    };
  },
  watch: {
    closeModel: {
      deep: true,
      handler() {
        if (this.closeModel) {
          const { closingId } = this.closeModel.data;

          this.isValid = closingId;
        }
      },
    },
  },
  methods: {
    closeDialogInit: function () {
      this.closeDialog = true;

      this.$api.get(`supportticket/close/${this.$route.params.id}`).then((response) => {
        this.closeModel = response.data;
        this.loaded = true;
      });
    },
    closeDialogSave: function () {
      this.saving = true;
      //todo: proper validation
      if (!this.closeModel.data.closingId) {
        //this is required
        return;
      }

      this.$api.put(`supportticket/close/${this.$route.params.id}`, this.closeModel.data).then((response) => {
        if (response.data.success) {
          this.saving = false;
          this.closeDialog = false;
          this.$emit("saved");
        } else {
          //TODO: Error handle...
        }
      });
    },
    closeDialogCancel: function () {
      this.closeModel = null;
      this.closeDialog = false;
      this.loaded = false;
    },
  },
};
</script>